<template>
    <v-card class="pa-2 app-screen-bg news-page">
        <div class="news-page__scroll">
            <div class="news-title-pill-wrap">
                <span class="news-title-pill">{{ $t('dashboard.news.titlePill') }}</span>
            </div>
            <v-card class="news-content-card" :class="$vuetify.theme.dark ? 'transparent03--dark' : 'transparent03'">
                <v-card-text :class="$vuetify.theme.dark ? 'white--text' : 'black--text'">
                    <NewsEntry
                        v-for="(entry, index) in pagedEntries"
                        :key="index"
                        :text="entry.text"
                        :img="entry.img"
                        :img-width-percent="entry.imgWidthPercent || 100"
                    />
                    <!-- cistě client-side (entries jsou staticke pole, zadny fetch) - stejny vzor jako PvpHub.vue -->
                    <v-pagination
                        v-if="pageCount > 1"
                        v-model="page"
                        :length="pageCount"
                        :total-visible="5"
                        class="news-pagination"
                    />
                </v-card-text>
            </v-card>
        </div>
    </v-card>
</template>

<script>
    import {newsEntries} from '@/config/newsEntries';
    import NewsEntry from '@/components/dashboard/NewsEntry';

    // Pocet novinek uz presahuje 50 - bez strankovani by zalozka byla jeden nekonecny scroll.
    const PAGE_SIZE = 50;

    export default {
        components: {NewsEntry},
        data() {
            return {
                page: 1,
            }
        },
        computed: {
            localizedEntries() {
                return newsEntries.map((entry) => ({
                    ...entry,
                    text: this.$t('dashboard.news.entries.' + entry.key),
                }));
            },
            pageCount() {
                return Math.max(1, Math.ceil(this.localizedEntries.length / PAGE_SIZE));
            },
            pagedEntries() {
                const start = (this.page - 1) * PAGE_SIZE;
                return this.localizedEntries.slice(start, start + PAGE_SIZE);
            },
        },
    }
</script>

<style scoped>
    /* ne 100vh - viz komentar u ".new-shell-ui .v-main" v App.vue */
    .news-page {
        height: 100%;
        display: flex;
        flex-direction: column;
    }

    .news-page__scroll {
        flex: 1 1 auto;
        min-height: 0;
        overflow-y: auto;
    }

    /* "position: sticky" primo uvnitr scrollovaci oblasti, ne flex sourozenec mimo ni - viz claude/architecture/frontend.md bod 8 */
    .news-title-pill-wrap {
        position: sticky;
        top: 0;
        z-index: 3;
        display: flex;
        justify-content: center;
        padding: 8px 0;
        background: transparent;
    }

    .news-title-pill {
        display: inline-block;
        background: rgba(0, 0, 0, .7);
        color: #fff;
        font-size: 20px;
        font-weight: 700;
        padding: 6px 20px;
        border-radius: 20px;
        text-shadow: 1px 1px 2px rgba(0, 0, 0, .6);
    }

    .news-content-card {
        max-width: 700px;
        margin: 0 auto;
    }

    .news-pagination {
        margin-top: 12px;
    }
</style>
